import * as React from "react";
import { FormattedMessage } from "react-intl";
import slugify from "slugify";
import Accordion from "./accordion";
import ButtonLink from "./button-link";

const slugOptions = {
  lower: true,
  strict: true,
  trim: true,
};

const Question = ({ questions, heading, product, destination }) => {
  const slug = heading && slugify(heading, slugOptions);

  if (questions) {
    return (
      <section
        className={`questions${product ? " questions-product" : ""}`}
        id={heading ? slug : "questions"}
        aria-labelledby={heading ? slug : "questions-heading"}
      >
        <div className="container">
          <div>
            <header>
              <h2 id={heading ? slug : "questions-heading"} className="heading">
                {heading || <FormattedMessage id="questionsHeading" />}
              </h2>
            </header>
            {(product || destination) && (
              <div className="questions-links">
                <ButtonLink href="/faq">
                  <FormattedMessage id="consultFAQ" />
                </ButtonLink>
                <ButtonLink href="/contact">
                  <FormattedMessage id="haveAQuestion" />
                </ButtonLink>
              </div>
            )}
            <div className="questions-list">
              {questions.map((question) => (
                <Accordion
                  key={question.contentful_id}
                  id={question.contentful_id}
                  title={question.title}
                  subheading={!heading}
                  category={question.category}
                  content={question.content}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }

  return null;
};

export default Question;
